import PageHero from "../components/PageHero";
import TerminalWindow from "../components/TerminalWindow";
import SkewButton from "../components/SkewButton";

const PUB = process.env.PUBLIC_URL || "";

const ACCEPTANCES = [
  "the weirdness",
  "the fashion trends",
  "the bass bombs",
  "the hair",
  "each other",
];

const APPRECIATIONS = [
  "His majestic white hair that seems to shine bright at every show",
  'His "Clifford Ball" look',
  "His peculiar weirdness we all seem to connect to one way or another",
  "His dear Nellie Kane and other bluegrass gems",
  "The Minkin's (DadaDadada!)",
  "The Shakedown appearances",
  "The social media clues to find Mike",
];

export default function MissionStatementPage() {
  return (
    <>
      <PageHero
        eyebrow="MGFC // doctrine"
        title="Mission Statement"
        tagline="◢ A directive from C-Suite ◣"
        image={`${PUB}/uploads/2018/08/Cx5ZQzjWIAUfwuO.jpg`}
        accent="magenta"
      />

      {/* COLD OPEN PULL-QUOTE ------------------------------------------------- */}
      <section className="mx-auto max-w-5xl px-4 pt-20 sm:px-6 lg:px-8">
        <blockquote className="relative border-l-2 border-mgfc-magenta pl-6 sm:pl-10">
          <p className="font-display text-2xl font-black uppercase leading-tight tracking-tight sm:text-4xl">
            <span className="gradient-text drop-shadow-[0_0_20px_rgba(255,0,255,0.4)]">
              Earth is 4.5 billion years old. The 100 years you may live are
              like a grain of sand in time. And you are here. And Mike is
              playing the bass — and you are not there.
            </span>
          </p>
          <p className="mt-6 font-mono text-sm uppercase tracking-[0.3em] text-mgfc-fg/60">
            That is your problem. Not mine.
          </p>
        </blockquote>
      </section>

      {/* BODY TERMINAL -------------------------------------------------------- */}
      <section className="mx-auto max-w-5xl px-4 py-20 sm:px-6 lg:px-8">
        <TerminalWindow title="mission-statement.txt" status="LAST EDIT // 2018">
          <div className="space-y-6 p-6 font-mono text-base leading-relaxed text-mgfc-fg/85 sm:p-10 sm:text-lg">
            <p>
              <span className="mr-2 text-mgfc-magenta">&gt;</span>
              You may call him Cactus. You may call him Gordo. You may just
              simply call him Mike. You may be chasing Minkin. You may be
              chasing Weigh. You're probably chasing any song that sounds so
              estrange.
            </p>
            <p>
              <span className="mr-2 text-mgfc-magenta">&gt;</span>
              You may be wondering how you got here, but rest assured, it's for
              good and funky reason. I'd like to welcome you to the official
              Mike Gordon Fan Club. We are just as happy you are here as Mike is
              when… well, you know Mike rarely <em className="not-italic text-mgfc-cyan">appears</em>{" "}
              happy. But that's what we love about him. There's a reason he is
              so fascinating. There is no other human in the world quite like{" "}
              <span className="text-mgfc-lime">Mr. Michael Gordon</span>. So… if
              you were able to connect to what was just said on any sort of
              level, you're in the right place, Pham.
            </p>
            <p>
              <span className="mr-2 text-mgfc-magenta">&gt;</span>
              The Mike Gordon Fan Club was started by people just like YOU —
              phans who spend their shows listening to those grooves, those
              bombs, those ever-lasting sploofs. It seems to us that those
              grooves can go on forever and never (laugh and laugh and) fall
              apart.
            </p>
            <p className="text-mgfc-fg/70">
              <span className="mr-2 text-mgfc-magenta">&gt;</span>
              But forth behold that it is not just the juicy rhythm that keeps
              us hooked. Passionate fans of Mike Gordon will also appreciate
              numerous of the following:
            </p>
            <ul className="ml-6 space-y-3 border-l border-mgfc-border/80 pl-6 text-mgfc-fg/85">
              {APPRECIATIONS.map((line, i) => (
                <li key={i}>
                  <span className="mr-3 text-mgfc-cyan">
                    [{String(i + 1).padStart(2, "0")}]
                  </span>
                  {line}
                </li>
              ))}
            </ul>
          </div>
        </TerminalWindow>
      </section>

      {/* WE ACCEPT GIANT GLYPHS ----------------------------------------------- */}
      <section className="mx-auto max-w-6xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="relative border-y-2 border-mgfc-cyan/40 py-10 sm:py-14">
          <p className="text-center font-mono text-xs uppercase tracking-[0.5em] text-mgfc-cyan">
            <span className="opacity-60">/// </span>
            in the fan club, we accept
          </p>
          <ul className="mt-10 flex flex-col items-center gap-3 text-center sm:gap-4">
            {ACCEPTANCES.map((item, i) => (
              <li
                key={item}
                className="font-display text-3xl font-black uppercase leading-none tracking-tight sm:text-5xl"
              >
                <span className="font-mono text-base text-mgfc-magenta sm:text-lg">
                  ◇{" "}
                </span>
                <span
                  className={[
                    "transition-colors duration-200 hover:text-glow-cyan",
                    i % 2 === 0 ? "text-mgfc-fg" : "gradient-text",
                  ].join(" ")}
                >
                  {item}
                </span>
              </li>
            ))}
          </ul>
          <p className="mt-10 text-center font-mono text-base leading-relaxed text-mgfc-fg/75 sm:text-lg">
            Make yourself at home, eat some meat, weigh your options,{" "}
            <span className="text-mgfc-lime">share in the groove</span>, and be
            weird. Have fun. <span className="text-mgfc-cyan">Do as Mike would do.</span>
          </p>
        </div>
      </section>

      {/* BIG QUOTE ------------------------------------------------------------ */}
      <section className="mx-auto max-w-5xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="relative">
          <p className="font-display text-2xl font-black uppercase leading-tight tracking-tight sm:text-4xl md:text-5xl">
            North Korea might say they have the strongest bombs in the world…
          </p>
          <p className="mt-4 font-display text-3xl font-black uppercase leading-tight tracking-tight sm:text-5xl md:text-6xl">
            <span className="gradient-text-mike">
              but have they heard Mike?
            </span>
          </p>
          <p className="mt-4 font-mono text-sm uppercase tracking-[0.3em] text-mgfc-fg/55">
            // i don&apos;t think so.
          </p>
        </div>
      </section>

      {/* CTA ------------------------------------------------------------------ */}
      <section className="mx-auto max-w-3xl px-4 pb-24 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-5">
          <SkewButton to="/newsletter" variant="magenta">
            ▸ Subscribe to dispatches
          </SkewButton>
          <SkewButton to="/scene" variant="lime">
            ▸ Drop into the void
          </SkewButton>
        </div>
      </section>
    </>
  );
}
